import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgContentCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-348.44 -348.44 2488.89 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1696 1152Q1736 1152 1764.0 1124.0Q1792 1096 1792 1056V-160Q1792 -200 1764.0 -228.0Q1736 -256 1696 -256H736Q696 -256 668.0 -228.0Q640 -200 640 -160V128H96Q56 128 28.0 156.0Q0 184 0 224V896Q0 936 20.0 984.0Q40 1032 68 1060L476 1468Q504 1496 552.0 1516.0Q600 1536 640 1536H1056Q1096 1536 1124.0 1508.0Q1152 1480 1152 1440V1112Q1220 1152 1280 1152ZM1152 939 853 640H1152ZM512 1323 213 1024H512ZM708 676 1024 992V1408H640V992Q640 952 612.0 924.0Q584 896 544 896H128V256H640V512Q640 552 660.0 600.0Q680 648 708 676ZM1664 -128V1024H1280V608Q1280 568 1252.0 540.0Q1224 512 1184 512H768V-128Z"
	})
});
export default SvgContentCopy;
